/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {useAuth} from '../../../../../app/modules/auth'

const PERFIL = {
  ADMIN: 1,
  ALUMNO: 2,
  PROFESOR: 3,
  PRECEPTOR: 4,
  PADRE: 5,
  PADRE_PERSONAL: 7,
  SECRETARIA: 6,
  EQORIENTACION: 8,
  DIRECTOR: 9,
  JPRECEPTORES: 10,
  BIBLIOTECARIA: 11,
} as const

const SidebarMenuMain = () => {
  const {currentUser} = useAuth()
  const perfil = Number(currentUser?.perfil)

  if (perfil === PERFIL.ADMIN) {
    return (
      <>
        <SidebarMenuItem to='/home/admin' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/alumnos/lista' icon='people' title='Alumnos' fontIcon='bi-people' />
        <SidebarMenuItem to='/padres/lista' icon='user' title='Padres' fontIcon='bi-person' />
        <SidebarMenuItem to='/profesores/lista' icon='teacher' title='Personal' fontIcon='bi-person-badge' />
        <SidebarMenuItem to='/materias/lista' icon='book' title='Materias' fontIcon='bi-book' />
        <SidebarMenuItem to='/cursos/lista' icon='element-11' title='Cursos' fontIcon='bi-layers' />
        <SidebarMenuItem to='/asistencias/lista' icon='notepad-edit' title='Asistencias' fontIcon='bi-journal-check' />
        <SidebarMenuItem to='/notasv2/lista' icon='notepad' title='RITE - Instancias' fontIcon='bi-journal-bookmark' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/auditoria' icon='eye' title='Auditoria de Mensajes' fontIcon='bi-eye' />
        <SidebarMenuItem to='/vacantes/lista' icon='document' title='Solicitud de Vacantes' fontIcon='bi-file-earmark-text' />        <SidebarMenuItemWithSub to='/estadisticas' icon='chart-simple' title='Estadísticas' fontIcon='bi-bar-chart'>
          <SidebarMenuItem to='/estadisticas/asistencias' hasBullet title='Asistencias' />
          <SidebarMenuItem to='/estadisticas/ausentismo' hasBullet title='Ausentismo' />
          <SidebarMenuItem to='/estadisticas/acceso-personal' hasBullet title='Acceso Personal' />
          <SidebarMenuItem to='/estadisticas/acceso-padres' hasBullet title='Acceso Padres' />
          <SidebarMenuItem to='/estadisticas/acceso-alumnos' hasBullet title='Acceso Alumnos' />
          <SidebarMenuItem to='/estadisticas/carga-docente' hasBullet title='Carga Docente' />
        </SidebarMenuItemWithSub>
      </>
    )
  }

  if (perfil === PERFIL.ALUMNO) {
    return (
      <>
        <SidebarMenuItem to='/home/alumno' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/cursos/alumno' icon='element-11' title='Mi Curso' fontIcon='bi-layers' />
        <SidebarMenuItem to='/asistencias/alumno' icon='notepad-edit' title='Mis Faltas' fontIcon='bi-journal-check' />
        <SidebarMenuItem to='/notas/alumno' icon='notepad' title='Mis Notas e Informes' fontIcon='bi-tag' />
        <SidebarMenuItem to='/notasv2/alumno' icon='notepad' title='Mis Notas RITE' fontIcon='bi-journal-richtext' />
        <SidebarMenuItem to='/tpsalumno/lista' icon='document' title='Mis Trabajos Practicos' fontIcon='bi-file-earmark-text' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/archivo' icon='sms' title='Mensajes Recibidos' fontIcon='bi-inbox' />
      </>
    )
  }

  if (perfil === PERFIL.PROFESOR) {
    return (
      <>
        <SidebarMenuItem to='/home/profesor' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/archivo' icon='sms' title='Mensajes Recibidos' fontIcon='bi-inbox' />
        <SidebarMenuItem to='/archivos/lista' icon='folder' title='Mis Archivos' fontIcon='bi-folder' />
        <SidebarMenuItem to='/notas/lista' icon='notepad' title='Notas e Informes' fontIcon='bi-tag' />
        <SidebarMenuItem to='/rite/lista' icon='note-2' title='RITE' fontIcon='bi-journal-text' />
        <SidebarMenuItem to='/tps/lista' icon='document' title='Trabajos Practicos' fontIcon='bi-file-earmark-text' />
      </>
    )
  }

  if (perfil === PERFIL.PADRE) {
    return (
      <>
        <SidebarMenuItem to='/home/padre' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/asistencias/padre' icon='notepad-edit' title='Inasistencias' fontIcon='bi-journal-check' />
        <SidebarMenuItem to='/notas/padre' icon='notepad' title='Notas e Informes' fontIcon='bi-tag' />
        <SidebarMenuItem to='/notasv2/padre' icon='note-2' title='Notas RITE' fontIcon='bi-journal-text' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/archivo' icon='sms' title='Mensajes Recibidos' fontIcon='bi-inbox' />
      </>
    )
  }

  if (perfil === PERFIL.PADRE_PERSONAL) {
    return (
      <>
        <SidebarMenuItem to='/home/multiperfil' icon='home' title='Seleccionar Perfil' fontIcon='bi-house' />
      </>
    )
  }

  if (perfil === PERFIL.PRECEPTOR) {
    return (
      <>
        <SidebarMenuItem to='/home/preceptor' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/alumnos/lista' icon='people' title='Alumnos' fontIcon='bi-people' />
        <SidebarMenuItem to='/padres/lista' icon='user' title='Padres' fontIcon='bi-person' />
        <SidebarMenuItem to='/cursos/lista' icon='element-11' title='Cursos' fontIcon='bi-layers' />
        <SidebarMenuItem to='/asistencias/lista' icon='notepad-edit' title='Asistencias' fontIcon='bi-journal-check' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/archivo' icon='sms' title='Mensajes Recibidos' fontIcon='bi-inbox' />
        <SidebarMenuItem to='/mensajes/auditoria' icon='eye' title='Auditoria de Mensajes' fontIcon='bi-eye' />
      </>
    )
  }

  if (perfil === PERFIL.SECRETARIA) {
    return (
      <>
        <SidebarMenuItem to='/home/preceptor' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/alumnos/lista' icon='people' title='Alumnos' fontIcon='bi-people' />
        <SidebarMenuItem to='/padres/lista' icon='user' title='Padres' fontIcon='bi-person' />
        <SidebarMenuItem to='/profesores/lista' icon='teacher' title='Personal' fontIcon='bi-person-badge' />
        <SidebarMenuItem to='/cursos/lista' icon='element-11' title='Cursos' fontIcon='bi-layers' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/archivo' icon='sms' title='Mensajes Recibidos' fontIcon='bi-inbox' />
        <SidebarMenuItem to='/mensajes/auditoria' icon='eye' title='Auditoria de Mensajes' fontIcon='bi-eye' />
        <SidebarMenuItem to='/vacantes/lista' icon='document' title='Solicitud de Vacantes' fontIcon='bi-file-earmark-text' />
      </>
    )
  }

  if (perfil === PERFIL.DIRECTOR) {
    return (
      <>
        <SidebarMenuItem to='/home/preceptor' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/alumnos/lista' icon='people' title='Alumnos' fontIcon='bi-people' />
        <SidebarMenuItem to='/padres/lista' icon='user' title='Padres' fontIcon='bi-person' />
        <SidebarMenuItem to='/profesores/lista' icon='teacher' title='Personal' fontIcon='bi-person-badge' />
        <SidebarMenuItem to='/cursos/lista' icon='element-11' title='Cursos' fontIcon='bi-layers' />
        <SidebarMenuItem to='/asistencias/lista' icon='notepad-edit' title='Asistencias' fontIcon='bi-journal-check' />
        <SidebarMenuItem to='/notasv2/lista' icon='notepad' title='RITE - Instancias' fontIcon='bi-journal-bookmark' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/archivo' icon='sms' title='Mensajes Recibidos' fontIcon='bi-inbox' />
        <SidebarMenuItem to='/mensajes/auditoria' icon='eye' title='Auditoria de Mensajes' fontIcon='bi-eye' />
        <SidebarMenuItem to='/vacantes/lista' icon='document' title='Solicitud de Vacantes' fontIcon='bi-file-earmark-text' />
        <SidebarMenuItemWithSub to='/estadisticas' icon='chart-simple' title='Estadísticas' fontIcon='bi-bar-chart'>
          <SidebarMenuItem to='/estadisticas/asistencias' hasBullet title='Asistencias' />
          <SidebarMenuItem to='/estadisticas/ausentismo' hasBullet title='Ausentismo' />
          <SidebarMenuItem to='/estadisticas/acceso-personal' hasBullet title='Acceso Personal' />
          <SidebarMenuItem to='/estadisticas/acceso-padres' hasBullet title='Acceso Padres' />
          <SidebarMenuItem to='/estadisticas/acceso-alumnos' hasBullet title='Acceso Alumnos' />
          <SidebarMenuItem to='/estadisticas/carga-docente' hasBullet title='Carga Docente' />
        </SidebarMenuItemWithSub>
      </>
    )
  }

  if (perfil === PERFIL.EQORIENTACION) {
    return (
      <>
        <SidebarMenuItem to='/home/preceptor' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/alumnos/lista' icon='people' title='Alumnos' fontIcon='bi-people' />
        <SidebarMenuItem to='/padres/lista' icon='user' title='Padres' fontIcon='bi-person' />
        <SidebarMenuItem to='/cursos/lista' icon='element-11' title='Cursos' fontIcon='bi-layers' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/archivo' icon='sms' title='Mensajes Recibidos' fontIcon='bi-inbox' />
        <SidebarMenuItem to='/vacantes/lista' icon='document' title='Solicitud de Vacantes' fontIcon='bi-file-earmark-text' />
      </>
    )
  }

  if (perfil === PERFIL.JPRECEPTORES) {
    return (
      <>
        <SidebarMenuItem to='/home/preceptor' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/alumnos/lista' icon='people' title='Alumnos' fontIcon='bi-people' />
        <SidebarMenuItem to='/padres/lista' icon='user' title='Padres' fontIcon='bi-person' />
        <SidebarMenuItem to='/profesores/lista' icon='teacher' title='Personal' fontIcon='bi-person-badge' />
        <SidebarMenuItem to='/cursos/lista' icon='element-11' title='Cursos' fontIcon='bi-layers' />
        <SidebarMenuItem to='/asistencias/lista' icon='notepad-edit' title='Asistencias' fontIcon='bi-journal-check' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/archivo' icon='sms' title='Mensajes Recibidos' fontIcon='bi-inbox' />
        <SidebarMenuItem to='/mensajes/auditoria' icon='eye' title='Auditoria de Mensajes' fontIcon='bi-eye' />
        <SidebarMenuItem to='/vacantes/lista' icon='document' title='Solicitud de Vacantes' fontIcon='bi-file-earmark-text' />
      </>
    )
  }

  if (perfil === PERFIL.BIBLIOTECARIA) {
    return (
      <>
        <SidebarMenuItem to='/home/preceptor' icon='home' title='Inicio' fontIcon='bi-house' />
        <SidebarMenuItem to='/mensajes/lista' icon='message-text-2' title='Mensajes Enviados' fontIcon='bi-envelope-open' />
        <SidebarMenuItem to='/mensajes/archivo' icon='sms' title='Mensajes Recibidos' fontIcon='bi-inbox' />
      </>
    )
  }

  // Fallback for unknown profiles
  return (
    <>
      <SidebarMenuItem to='/home/preceptor' icon='home' title='Inicio' fontIcon='bi-house' />
    </>
  )
}

export {SidebarMenuMain}
